import { create } from 'zustand';
import { reviewsAPI } from '../api/services';

const useReviewStore = create((set) => ({
  reviews: [],
  loading: false,
  error: null,
  pagination: { current: 1, pageSize: 15, total: 0 },

  fetchReviews: async (params = {}) => {
    set({ loading: true });
    try {
      const res = await reviewsAPI.getAll(params);
      const data = res.data?.data || res.data;
      set({
        reviews: Array.isArray(data) ? data : data?.data || [],
        pagination: {
          current: data?.current_page || 1,
          pageSize: data?.per_page || 15,
          total: data?.total || 0,
        },
        loading: false,
      });
    } catch (err) {
      set({ error: err.message, loading: false });
    }
  },

  deleteReview: async (id) => {
    await reviewsAPI.delete(id);
  },
}));

export default useReviewStore;
